module.exports = __webpack_public_path__ + "img/9788956372761.1dc94603.jpg";